import { InviteStatus } from '@/types/api/invite';

export function inviteInvalidMessage(status: InviteStatus): string {
  // prettier-ignore
  switch(status) {
    case InviteStatus.Exhausted: return "Inbjudan har använts för många gånger."
    case InviteStatus.Expired:   return "Inbjudan har gått ut."
    case InviteStatus.Revoked:   return "Inbjudan har återkallats."
    default:                     return "Är ogiltig."
  }
}
